import mockAxios, { AxiosResponse } from 'axios';

import { IPaymentRequisitionServiceMock } from './paymentrequisition.mock.types';
import { IPaymentRequisitionData } from '@/models';

export const mockPaymentRequisitionService = (): IPaymentRequisitionServiceMock => ({
  fetchPaymentRequisitions: jest.fn(),
  fetchPaymentRequisition: jest.fn(),
  createPaymentRequisition: jest.fn(),
  updatePaymentRequisition: jest.fn(),
  deletePaymentRequisition: jest.fn(),
  updatePaymentRequisitionLine: jest.fn(),
  deletePaymentRequisitionAttachment: jest.fn(),
  updatePaymentRequisitionState: jest.fn(),
  fetchRequisitionAPSpecialists: jest.fn(),
  assignRequisitionAPSpecialist: jest.fn(),
  fetchPaymentRequisitionApprovers: jest.fn(),
  assignPaymentRequisitionApprover: jest.fn(),
  updatePaymentRequisitionOwner: jest.fn(),
  fetchPaymentRequisitionActivities: jest.fn(),
  // comments
  fetchPaymentRequisitionComments: jest.fn(),
  fetchPaymentRequisitionComment: jest.fn(),
  createPaymentRequisitionComment: jest.fn(),
  updatePaymentRequisitionComment: jest.fn(),
  deletePaymentRequisitionComment: jest.fn(),
  addPaymentRequisitionCommentAttachments: jest.fn(),
  removePaymentRequisitionCommentAttachment: jest.fn(),
  fetchPaymentRequisitionCommentsMentionableUsers: jest.fn(),

  //export
  exportPaymentRequisitionPdf: jest.fn(),
  exportPaymentRequisitions: jest.fn(),

  updateMultiplePaymentRequisitionOwner: jest.fn()
});

export const mockPaymentRequisitionAxiosResponse = <
  T = IPaymentRequisitionData
>(
  data?: T
): AxiosResponse<T | undefined> => {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
};
